import { InfoOutlined } from '@mui/icons-material';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/access/entrance.png';
const detailImage = '/access/stairs.jpg';
const mapsEmbedSrc = 'https://maps.google.com/maps?q=%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%96%87%E4%BA%AC%E5%8C%BA%E5%B0%8F%E7%9F%B3%E5%B7%9D1-8-7%20AKA%E3%83%93%E3%83%AB201&output=embed';

const Access = () => (
    <DocPageLayout
        currentRoute="/access"
        pageLabel="ACCESS"
        pageTitle="アクセス"
        heroPadding="compact"
    >


        <article className="doc-section">
            
            <div className="doc-section__body">
                
                <p>三田線 春日駅 A5番出口 徒歩1分</p>
                <p>東京都文京区小石川1-8-7 AKAビル201</p>
                <div className="doc-section__media doc-section__media--full">
                    <img src={heroImage} alt="春日駅から徒歩1分の外観" loading="lazy" />
                </div>
            </div>
        </article>
                

        <article className="doc-section">
            
            <div className="doc-section__body">
                
                <p>Google Map</p>
                <div className="doc-section__map">
                    <iframe
                        title="TAKAJYU鍼灸・整体院 Google マップ"
                        src={mapsEmbedSrc}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <InfoOutlined className="doc-section__icon" />詳細
            </h3>
            <div className="doc-section__body">
                <p>
                    AKAビル1階が高木歯科になります。歯医者さんの入り口から入り、正面の階段を昇ってください。エレベータの隣の201号室が当院です。
                </p>
                <div className="doc-section__media doc-section__media--plain">
                    <img src={detailImage} alt="AKAビルの階段" loading="lazy" />
                </div>
            </div>
        </article>
    </DocPageLayout>
);

export default Access;


